import { Colors } from '../Colors';

const inputStyles = {
    label: {
        color: Colors.text,
        fontWeight: 400,
        marginBottom: '.25rem',
        fontSize: '.875rem',
    },
    input: {
        boxShadow: '0 1px 2px 0 rgb(0 0 0 / 5%)',
    },
};

const Input = {
    defaultProps: {
        size: 'md',
    },
    styles: inputStyles,
};

const InputBase = {
    defaultProps: {
        size: 'md',
    },
    styles: inputStyles,
};

const TextInput = {
    defaultProps: {
        size: 'md',
    },
    styles: inputStyles,
};

const NumberInput = {
    defaultProps: {
        size: 'md',
    },
    styles: inputStyles,
};

const DateInput = {
    defaultProps: {
        size: 'md',
    },
    styles: inputStyles,
};

const PasswordInput = {
    defaultProps: {
        size: 'md',
    },
    styles: inputStyles,
};

const Select = {
    defaultProps: {
        size: 'md',
    },
    styles: inputStyles,
};

const PillsInput = {
    defaultProps: {
        size: 'md',
    },
    styles: inputStyles,
};

const MultiSelect = {
    defaultProps: {
        size: 'md',
    },
    styles: inputStyles,
};

const Textarea = {
    defaultProps: {
        size: 'md',
    },
    styles: inputStyles,
};

export default {
    DateInput,
    Input,
    InputBase,
    MultiSelect,
    NumberInput,
    PasswordInput,
    PillsInput,
    Select,
    Textarea,
    TextInput,
};
